import {createBrowserRouter} from "react-router-dom";
import RootRouter from "./RootRoutes";
import ErrorPage from "../pages/error-page";
import SignIn from "../pages/signin";
import {routes} from "../common/routes";
import ManageProgram from "../pages/ManageProgram/ManageProgram";
import ManageProgramCreate from "../pages/ManageProgram/ManageProgramCreate";
import ManageClubJoin from "../pages/ManageClubJoin/ManageClubJoin";
import SearchClubInfo from "src/pages/SearchInfo/SearchClubInfo";
import SearchPlayerInfo from "../pages/SearchInfo/SearchPlayerInfo";
import ClubDetails from "../pages/SearchInfo/ClubDetails";
import PlayerDetails from "../pages/SearchInfo/PlayerDetails";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootRouter baseUrl={routes.baseUrl} />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "signin",
        element: <SignIn />,
      },
      {
        path: "manage-program",
        element: <ManageProgram />
      },
      {
        path: "manage-program/create",
        element: <ManageProgramCreate />
      },
      {
        path: "manage-program/:programId",
        element: <ManageProgramCreate />
      },
      {
        path: "manage-club-join/:active",
        element: <ManageClubJoin />
      },
      {
        path: "manage-club-join/activePaid/:clubId",
        element: <ClubDetails />
      },
      {
        path: "manage-club-join/activeUnpaid/:clubId",
        element: <ClubDetails />
      },
      {
        path: "manage-club-join/inactive/:clubId",
        element: <ClubDetails />
      },
      {
        path: "search-info/club",
        element: <SearchClubInfo />,
      },
      {
        path: "search-info/player",
        element: <SearchPlayerInfo />,
      },
      {
        path: "search-info/club/:clubId",
        element: <ClubDetails />,
      },
      {
        path: "search-info/player/:playerId",
        element: <PlayerDetails />,
      }
    ]
  }
])